<template>
	<div class="meiti-type-warning">

		<div class="themName">{{themName}}:</div>
		<div class="thems">

			<el-row>
				<el-col :span="3">
					<div class="lisitems" :class="[all ?selected: '']">
						<div class="textC">
							<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全部</el-checkbox>
						</div>
					</div>
				</el-col>
				<el-checkbox-group v-model="checkList" @change="handleCheckedChange">
					<el-col :span="3">
						<div class="lisitems" :class="[defaultValue.indexOf('1') !== -1 ?selected: '']">
							<div class="textC">
								<el-checkbox label="1">新闻</el-checkbox>
							</div>
						</div>
					</el-col>
					<el-col :span="3">
						<div class="lisitems weiboDiv" :class="[defaultValue.indexOf('4') !== -1 ?selected: '']">
							<div class="textC">
								<el-checkbox label="4" >微博</el-checkbox>
							</div>
						</div>

					</el-col>
					<el-col :span="3">
						<div class="lisitems" :class="[defaultValue.indexOf('9') !== -1 ?selected: '']">
							<div class="textC">
								<el-checkbox label="9">微信</el-checkbox>
							</div>
						</div>
					</el-col>
					<el-col :span="3">
						<div class="lisitems" :class="[defaultValue.indexOf('2') !== -1 ?selected: '']">
							<div class="textC">
								<el-checkbox label="2">论坛</el-checkbox>
							</div>
						</div>
					</el-col>
					<el-col :span="3">
						<div class="lisitems" :class="[defaultValue.indexOf('3') !== -1 ?selected: '']">
							<div class="textC">
								<el-checkbox label="3">博客</el-checkbox>
							</div>
						</div>
					</el-col>
					<el-col :span="3">
						<div class="lisitems" :class="[defaultValue.indexOf('8') !== -1 ?selected: '']">
							<div class="textC">
								<el-checkbox label="8">客户端</el-checkbox>
							</div>
						</div>
					</el-col>
					<el-col :span="3">
						<div class="lisitems" :class="[defaultValue.indexOf('10') !== -1 ?selected: '']">
							<div class="textC">
								<el-checkbox label="10">视频</el-checkbox>
							</div>
						</div>
					</el-col>
				</el-checkbox-group>
			</el-row>
		</div>
		<!-- <span class="themlis" :class="[isSelected === `${item.uuid}` ?selected: '']" @click="seletedF(item.uuid)" v-for="item in list" :key="item.uuid">{{item.name}}</span> -->
	</div>
</template>

<script>
    const checkOptions = ['1', '2', '3', '4','8','9','10'];
    export default {
        data() {
            return {
                isOrg:'',
                isIndeterminate: false,
                checkAll: true,
                checkList:['1','4','9','2','3','8','10'],
                all: true,
                selected: {
                    selectedClass: true,
                    textColor: true,
                    borderColor: true
                },
                isSelected: '',
                value1: '',
                molist: [{
                    uuid: 'all',
                    name: '全部'
                }]
            }
        },

        props: {
            themName: {
                type: String,
                default: '状态'
            },
            list: {
                type: Array,
                default: () => {
                    []
                }
            },
            defaultValue:{
                type: Array,
                default: () => {
                    []
                }
            },

        },
        mounted() {
            this.all = true
            // this.isSelected = this.list[0].uuid
        },
        watch:{
            defaultValue(val,oldValue){
                this.checkList = val;
            }
        },
        methods: {
            handleCheckAllChange(val) {
                this.checkList = val ? checkOptions : [];
                this.isIndeterminate = false;
                this.$emit('changeMeiti',this.checkList);
            },
            handleCheckedChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === 7;
                this.isIndeterminate = checkedCount > 0 && checkedCount < 7;
                this.$emit('changeMeiti',this.checkList);
            },
            seletedF(val) {
                this.isSelected = val
                this.$emit('changeVal', {
                    'type': val,
                    'val': null
                })
            },
            timeChange(val) {
                this.$emit('changeVal', {
                    'type': this.isSelected,
                    'val': val
                })
            },
        }
    }
</script>

<style lang="less">
	.el-checkbox-group{
		font-size: 14px;
	}
	.meiti-type-warning {
		font-size: 14px;
		// margin-top: 10px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		// .themlis {
		// 	margin-left: 10px;
		// 	display: inline-block;
		// 	padding: 0px 5px;
		// 	height: 24px;
		// 	line-height: 24px;
		// 	border: 1px solid transparent;
		// 	border-radius: 5px;
		//           cursor: pointer;

		// 	&.selectedClass {
		// 		// color: #41a0ff;
		// 		border: 1px solid #41a0ff;
		// 		border-radius: 5px;
		// 	}
		// }

		.themName {
			color: @huiseColor;
			height: 40px;
			line-height: 40px;
		}

		.thems {
			width: calc(100% - 60px);
		}

		.lisitems {
			//flex:1;
			width: 66px;
			margin-left: 56px;

			&:first-child {
				margin-left: 10px;
			}

			.dashLine {
				border-bottom: 1px dashed @huiseColor;

				.el-checkbox__label {
					padding-left: 5px;
				}
			}

			&>div {
				padding: 0px 6px;
			}
		}

		.weiboDiv {
			position: relative;

			.checkDiv {
				display: none;
				position: absolute;
				width: 154px;
				height: 36px;
				background-color: #fff;
				top: -36px;
				left: 50%;
				border: 1px solid #EBEEF5;
				box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
				border-radius: 4px;
				transform: translateX(-50%);
				padding-top:8px;
				.el-checkbox{
					margin: 0px 5px;
				}
				.arrow {
					position: absolute;
					display: block;
					width: 0;
					height: 0;
					border-color: transparent;
					border-style: solid;
					border-width: 6px;
					-webkit-filter: drop-shadow(0 2px 12px rgba(0, 0, 0, .03));
					filter: drop-shadow(0 2px 12px rgba(0, 0, 0, .03));
					bottom: -6px;
					left: 50%;
					margin-right: 3px;
					border-top-color: #EBEEF5;
					border-bottom-width: 0;
					transform: translateX(-50%);
					&::after {
						position: absolute;
						display: block;
						width: 0;
						height: 0;
						border-color: transparent;
						border-style: solid;
						content: " ";
						border-width: 6px;
						bottom: 1px;
						margin-left: -6px;
						border-top-color: #FFF;
						border-bottom-width: 0;
					}
				}
			}
			&:hover{
				.checkDiv{
					display: block;
				}
			}
		}

	}
	.timePublic .lisitems .dashLine{
		border-bottom: 0px dashed #999999;
	}
</style>
